import { showPopoverContent } from "./utils";

document.addEventListener("DOMContentLoaded", function () {
  const mainContent = document.querySelector(".popover-links");

  if (mainContent) {
    // Popover.
    const popoverWrap = document.querySelector(".popover-wrap");
    const contentLinks = document.querySelectorAll(".popover-links a");
    let timer;

    // Popover observer
    function observeIntersection(currentLink) {
      const observerOpts = {
        threshold: 1.0,
      };
      const observerCallback = (entries, observer) => {
        const entry = entries[0];
        if (!entry.isIntersecting) {
          const diff =
            entry.boundingClientRect.bottom -
            currentLink.getBoundingClientRect().top +
            20;
          entry.target.style.transform = `translateY(-${diff}px)`;
        }
        observer.disconnect();
      };
      let observer = new IntersectionObserver(observerCallback, observerOpts);
      observer.observe(popoverWrap);
    }

    for (const contentLink of contentLinks) {
      contentLink.addEventListener("mouseenter", (e) => {
        popoverWrap.style.transform = "none";
        timer = setTimeout(() => {
          popoverWrap.classList.remove("active");

          const href = contentLink.getAttribute("href"),
            currentURL = new URL(href, window.location.origin),
            path = currentURL.pathname;

          if (!path.includes("/articles/")) {
            popoverWrap.classList.remove("active");
            return;
          }

          if (contentLink.getAttribute("data-no-popover")) {
            popoverWrap.classList.remove("active");
            return;
          }

          if (contentLink.getAttribute("data-cached")) {
            showPopoverContent(e, popoverWrap);
            observeIntersection(contentLink);
          } else {
            popoverWrap.classList.add("active");
            popoverWrap.classList.add("loading");
            observeIntersection(contentLink);
            jQuery.get(
              LOCALIZED.ajax_url,
              {
                action: "nge_get_detail_from_url",
                href: href,
                nonce: LOCALIZED.ajax_nonce,
              },
              (result) => {
                if (true == result.success) {
                  const data = result.data;
                  contentLink.setAttribute("data-cached", 1);
                  contentLink.setAttribute(
                    "data-title",
                    data.title ? data.title : ""
                  );
                  contentLink.setAttribute(
                    "data-meta",
                    data.meta ? data.meta : ""
                  );
                  contentLink.setAttribute(
                    "data-description",
                    data.description ? data.description : ""
                  );
                  contentLink.setAttribute(
                    "data-image",
                    data.image ? data.image : ""
                  );
                } else {
                  contentLink.setAttribute("data-cached", 1);
                  contentLink.setAttribute("data-no-popover", 1);
                }
                popoverWrap.classList.remove("loading");
                showPopoverContent(e, popoverWrap);
                requestAnimationFrame(() => observeIntersection(contentLink));
              }
            );
          }

          // Get positioning
          let main = document.querySelector(".site-main");
          let mainRect = main.getBoundingClientRect();
          let anchorRect = contentLink.getBoundingClientRect();
          let offsetX = anchorRect.left + contentLink.offsetWidth * 0.5 - 110;
          let offsetY = anchorRect.top - mainRect.top + 130;

          popoverWrap.classList.add("active");
          popoverWrap.style.left = offsetX + "px";
          popoverWrap.style.top = offsetY + "px";
        }, 300);
      });

      contentLink.addEventListener("mouseout", () => {
        clearTimeout(timer);
        if (popoverWrap.classList.contains("active")) {
          popoverWrap.classList.remove("active");
        }
      });
    }
  }
});
